export enum Target {
    Blank = '_blank',
    Parent = '_parent',
    Self = '_self',
}
